import * as React from "react";
import {match, Redirect, Switch} from "react-router";
import RestrictedRoute from "./route/RestrictedRoute";
import {UserPermission} from "../model/user/UserPermission";
import BrandList from "../components/admin/brands/BrandList";
import BrandCreate from "../components/admin/brands/BrandCreate";
import BrandEdit from "../components/admin/brands/BrandEdit";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Contact router view.
 */
export default class BrandRouter extends React.PureComponent <RouteProps, {}> {

	render() {
		return (
			<Switch>
				<RestrictedRoute exact
								 path={this.props.match.url}
								 component={BrandList}
								 allowedPermissions={[UserPermission.AdminUsers]}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/create"}
								 component={BrandCreate}
								 allowedPermissions={[UserPermission.AdminUsers]}/>
				<RestrictedRoute path={this.props.match.url + "/:brandId"}
								 component={BrandEdit}
								 allowedPermissions={[UserPermission.AdminUsers]}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}

}